import { Link } from "react-router";
import { Avatar } from "@/components/common/Avatar";

type Person = { id: string; formattedName?: string | null; avatar?: { content?: string | null; mimeType?: string | null } | null };

/** Small operator identity, using the ordinary profile route and shared avatar. */
export function OrganizationalRecordPerson({ person }: { person?: Person | null }) {
  if (!person) return <span>–</span>;
  return <Link to={`/p/${person.id}`} className="inline-flex min-w-0 max-w-full items-center gap-2 field-meta hover:underline">
    <Avatar size="sm" person={{ name: person.formattedName ?? "–", avatarContent: person.avatar?.content, avatarMime: person.avatar?.mimeType }} />
    <span className="truncate">{person.formattedName ?? "–"}</span>
  </Link>;
}
